import { render, staticRenderFns } from "./ConfigSmsMessage.vue?vue&type=template&id=4a613a13&scoped=true&"
import script from "./ConfigSmsMessage.vue?vue&type=script&lang=js&"
export * from "./ConfigSmsMessage.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSmsMessage.vue?vue&type=style&index=0&id=4a613a13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a613a13",
  null
  
)

export default component.exports